<template>
  <div class="about">
    <div class="about-content">
      <div class="decoration-element">
        <div class="decoration-element-2"></div>
      </div>
      <div class="row row-1">
        <div class="img-and-text">
          <img class="row-1-top-img" src="../../assets/img/about/img1.jpg">
          <div class="text-group">
            <h3 class="text-accent">{{ $t('about-1') }}</h3>
            <h1>{{ $t('about-2') }}</h1>
            <p v-html="$t('about-3-pre')"></p>
            <p>{{ $t('about-3') }}</p>
            <p>{{ $t('about-3-1') }}</p>
            <p>{{ $t('about-3-2') }}</p>
          </div>
        </div>
        <div class="right"></div>
        <img src="../../assets/img/about/img2.jpg" class="right-img">
      </div>
      <div class="row row-2">
        <div class="text-group">
          <h3 class="text-accent">{{ $t('about-6') }}</h3>
          <h1>{{ $t('about-7') }}</h1>
        </div>
        <img v-if="$i18n.locale === 'bg'" id="aboutScheme" class="scheme" src="../../assets/img/about/scheme_bg.svg" alt>
        <img v-if="$i18n.locale === 'en'" id="aboutScheme" class="scheme" src="../../assets/img/about/scheme_en.svg" alt>
      </div>
      <AdditionalInfo :text2="$t('about-9')"/>
    </div>
    <VideoGallery/>
  </div>
</template>

<script>
import VideoGallery from "../shared/VideoGallery";
import AdditionalInfo from "./AdditionalInfo";
export default {
  components: {
    VideoGallery,
    AdditionalInfo
  },
  mounted() {
    if (this.$route.query.scroll) {
      setTimeout(() => {
        const targetElement = document.getElementById(this.$route.query.scroll);
        targetElement.scrollIntoView({ behavior: "smooth" });
      }, 1500);
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  .about-content {
    position: relative;
    .row-1 {
      justify-content: space-between;
      align-items: stretch;
      .right {
        @extend %flex-center;
        align-items: flex-end;
        background-image: url("../../assets/img/about/img2.jpg");
        background-size: cover;
        background-position: center;
        flex-direction: column;
        margin-left: 5%;
        margin-top: $sidesPadding;
        width: 45%;
      }
      .right-img {
        display: none;
      }
    }
    .row-2 {
      display: block;
      padding: 0 $sidesPadding;
      position: relative;
      .text-group {
        width: 62%;
        // h1 {
        //   margin: 30px 0;
        // }
      }
      .scheme {
        display: block;
        height: auto;
        margin-bottom: 30px;
        margin-top: -3vw;
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .about {
    .about-content {
      .row-1 {
        .right {
          margin-top: $sidesPadding1600;
        }
      }
      .row-2 {
        padding: 0 $sidesPadding1600;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .about {
    .about-content {
      .row-1 {
        .right {
          margin-top: $sidesPadding1280;
        }
      }
      .row-2 {
        padding: 0 $sidesPadding1280;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .about {
    .about-content {
      .row-1 {
        padding-top: 0;
        flex-direction: column;
        .img-and-text {
          width: 100%;
          .text-group {
            margin-top: 0;
            padding: $sidesPadding1280;
          }
          img {
            display: none;
          }
        }
        .right {
          display: none;
        }
        .right-img {
          display: block;
          height: auto;
          width: 100%;
        }
      }
      .row-2 {
        .text-group {
          width: 100%;
        }
        .scheme {
          margin-top: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .about {
    .about-content {
      .row-1 {
        .img-and-text {
          .text-group {
            margin-top: 0;
            padding: $sidesPadding600;
          }
        }
        .right {
          margin-top: $sidesPadding600;
        }
      }
      .row-2 {
        padding: 0 $sidesPadding600;
      }
    }
  }
}
</style>
